<script lang="ts">
    import { onMount } from 'svelte';

    import {
        currency as currencyStore,
        exchangeRate as exchangeRateStore,
    } from '$saga/store/currency';
    import { locale as localeStore } from '$saga/store/locale';
    import type { Currency } from '$saga/utils/currency';

    export let currency: string;
    export let locale: string;
    export let exchangeRate: string;

    onMount(() => {
        $currencyStore = currency as Currency;
        $localeStore = locale;
        $exchangeRateStore = Number(exchangeRate);
    });
</script>
